import React, { useState } from "react";
import { useParams, Link } from "react-router-dom";
import { confirmPasswordReset } from "../api/UserAPI";

function ResetPassword() {
  const { uid, token } = useParams();

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (password !== confirm) {
      setError("Passwords do not match.");
      return;
    }

    setLoading(true);
    try {
      await confirmPasswordReset(uid, token, password, confirm);
      setSuccess(true);
    } catch (err) {
      const detail =
        err?.response?.data?.new_password2?.[0] ||
        err?.response?.data?.token?.[0] ||
        err?.response?.data?.uid?.[0] ||
        err?.response?.data?.detail ||
        "Something went wrong. This link may have expired.";
      setError(detail);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col lg:flex-row w-screen">
      <div className="flex items-center justify-center border-blue-500 lg:h-screen lg:border-r lg:w-3/5">
        <div className="flex items-center justify-center lg:h-screen">
          <img
            src={`${process.env.PUBLIC_URL}/blorp_logo.png`}
            alt="[Tink Art]"
            className="w-48 h-48 object-contain lg:w-72 lg:h-72"
          />
        </div>
      </div>
      <div className="flex flex-col max-w-md my-auto mx-auto lg:w-2/5">
        <div className="p-4 max-w-md mx-auto w-full">
          <h1 className="text-xl font-bold mb-4">Set New Password</h1>
          {success ? (
            <div>
              <p className="text-sm text-gray-700 mb-4">
                Your password has been reset. You can now log in with your new password.
              </p>
              <Link to="/login">
                <button className="bg-blue-500 text-white w-full px-4 py-2 rounded hover:bg-black hover:text-white">
                  Go to Login
                </button>
              </Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <input
                type="password"
                placeholder="New password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="w-full mb-2 p-2 border rounded"
              />
              <input
                type="password"
                placeholder="Confirm new password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                required
                className="w-full mb-2 p-2 border rounded"
              />
              {error && (
                <p className="text-sm text-red-500 mb-2">{error}</p>
              )}
              <button
                type="submit"
                disabled={loading}
                className="bg-blue-500 text-white w-full px-4 py-2 mb-2 rounded hover:bg-black hover:text-white disabled:opacity-50"
              >
                {loading ? "Resetting..." : "Reset Password"}
              </button>
              <Link to="/login" className="text-sm text-blue-500 hover:underline block text-center">
                Back to login
              </Link>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;
